import {
  bancoDoBrasil,
  caixa,
  citi,
  hsbc,
  banrisul,
  santander,
  itau,
  bradesco,
  bankPlaceholder
} from 'assets/banks'

const bankAvatarList = {
  '001': bancoDoBrasil,
  237: bradesco,
  104: caixa,
  '041': banrisul,
  '033': santander,
  341: itau,
  399: hsbc,
  168: hsbc,
  745: citi
}

const defineBankAvatar = bankNumber => bankAvatarList[bankNumber] || bankPlaceholder

export default defineBankAvatar
